import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Shield, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const { language } = useLanguage();

  const content = {
    fr: {
      tagline: 'Sécurisez vos dépôts, protégez vos revenus',
      company: 'Entreprise',
      about: 'À propos',
      services: 'Services',
      blog: 'Blog',
      contact: 'Contact',
      legal: 'Légal',
      terms: 'Conditions d\'utilisation',
      privacy: 'Politique de confidentialité',
      mentions: 'Mentions légales',
      contactUs: 'Nous contacter',
      location: 'France',
      rights: 'Tous droits réservés',
      disclaimer: 'DépôtSecure - Modèles et conseils pour sécuriser vos dépôts de garantie. Service non juridique.'
    },
    en: {
      tagline: 'Secure your deposits, protect your income',
      company: 'Company',
      about: 'About',
      services: 'Services',
      blog: 'Blog',
      contact: 'Contact',
      legal: 'Legal',
      terms: 'Terms of Service',
      privacy: 'Privacy Policy',
      mentions: 'Legal Notice',
      contactUs: 'Contact Us',
      location: 'France',
      rights: 'All rights reserved',
      disclaimer: 'DepositSecure - Templates and advice to secure your deposits. Non-legal service.'
    }
  };

  const t = content[language];

  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <div className="bg-gradient-to-br from-blue-700 to-blue-600 p-2 rounded-lg">
                <Shield className="h-5 w-5 text-white" />
              </div>
              <span className="text-lg font-bold text-white">
                {language === 'fr' ? 'DépôtSecure' : 'DepositSecure'}
              </span>
            </Link>
            <p className="text-sm text-slate-400 mb-4">{t.tagline}</p>
            <div className="flex items-start space-x-2 text-sm text-slate-400">
              <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
              <span>{t.location}</span>
            </div>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t.company}</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-white transition-colors">
                  {t.about}
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-white transition-colors">
                  {t.services}
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-white transition-colors">
                  {t.blog}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition-colors">
                  {t.contact}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t.legal}</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  {t.terms}
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  {t.privacy}
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  {t.mentions}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t.contactUs}</h3>
            <div className="flex items-center space-x-2 text-sm">
              <Mail className="h-4 w-4" />
              <a href="mailto:contact@depotsecure.net" className="hover:text-white transition-colors">
                contact@depotsecure.net
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-slate-400">
              © {new Date().getFullYear()} {language === 'fr' ? 'DépôtSecure' : 'DepositSecure'}. {t.rights}
            </p>
            <p className="text-xs text-slate-500 max-w-md text-center md:text-right">
              {t.disclaimer}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
